module.exports = __webpack_public_path__ + "img/online_bg_2025_04_25.4f44b2a5.png";